module.exports = __webpack_public_path__ + "img/entity-news-no-data.ccbbc9ce.svg";